import React from 'react'
import classes from './EmptyState.module.css'
import { emptyState } from '../../../../../../assets/images'
import { useDispatch } from 'react-redux'
import { setOpenAddNewTimeTable } from '../../../../../../redux/globalSlice'
const EmptyState = () => {
  const dispatch=useDispatch()
  return (
    <div className={classes.container}>
      <div className={classes.box}>
        <img src={emptyState} alt="" className={classes.imgbox} />
        <p className={classes.headtxt}>Add new Timetable to Continue</p>
        <p className={classes.subtxt}>
          Add a timetable for teacher or for a class that will be shown here!
        </p>
        <button onClick={()=>{
          dispatch(setOpenAddNewTimeTable(true))
        }} className={classes.btn}>+ Add TimeTable</button>
      </div>
    </div>
  )
}

export default EmptyState
